import { Grid, Spacer } from "@chakra-ui/layout";
import { GridProps } from "@chakra-ui/react";
import { InputControl, SelectControl } from "formik-chakra-ui";
import { TagTextInput } from "src/components/Inputs/MultiSelectInput";
import { isAllowedIpOrCidr } from "src/services/ipRestriction";

type UserGroupOption = {
  id: string;
  name: string;
  label: string;
};

type TeamOption = {
  id: string;
  name: string;
};

type Props = {
  userGroups: UserGroupOption[];
  teams: TeamOption[];
  disableRole?: boolean;
} & GridProps;

export const ApiCredentialForm: React.FC<Props> = ({
  userGroups,
  disableRole = false,
  teams,
  ...props
}) => {
  return (
    <Grid templateColumns={"repeat(2, 1fr)"} gap={8} {...props}>
      <InputControl
        inputProps={{
          placeholder: "e.g. Demo API Client",
        }}
        w="100%"
        id="client_name"
        name="client_name"
        label="API Client Name"
        isRequired
      />
      <SelectControl
        label="Role"
        name="role"
        isRequired
        selectProps={{ placeholder: "Select a role" }}
      >
        {userGroups
          .filter((group) => group.name === "org_admin")
          .map((group) => (
            <option key={group.id} value={group.id}>
              {group.label}
            </option>
          ))}
      </SelectControl>

      <SelectControl
        label="Team"
        name="team_id"
        selectProps={{ placeholder: "Select a team" }}
      >
        {teams.map((team) => (
          <option key={team.id} value={team.id}>
            {team.name}
          </option>
        ))}
      </SelectControl>

      <Spacer />

      <TagTextInput
        name="allowed_ips"
        label="Allowed IPs"
        placeholder="e.g. 203.0.113.10 or 10.0.0.0/8"
        isInvalidItem={(value) => !isAllowedIpOrCidr(value)}
        getInvalidItemMessage={() =>
          "Each entry must be a valid IP address or CIDR"
        }
        duplicateErrorMessage="Duplicate IP addresses are not allowed"
      />
    </Grid>
  );
};
